import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Pipe({
  name: 'queDateHourFormatAmPm',
  standalone: true
})
export class QueDateHourFormatAmPmPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(hour: number | null): SafeHtml {
    let htmlString = "";
    if (hour !== null) {
      switch (true) {
        case (hour === 0 ):
          htmlString = `<div class="hour-formet-am-pm"><span> 12:00 </span><span> am </span></div>`;
          break;
          case (hour === 12):
          htmlString = `<div class="hour-formet-am-pm"><span> 12:00 </span><span> pm </span></div>`;
          break;
        case (hour > 0 && hour < 12):
          htmlString = `<div class="hour-formet-am-pm"><span> ${hour}:00 </span><span> am </span></div>`;
          break;
        case (hour > 12 && hour < 24):
          htmlString = `<div class="hour-formet-am-pm"><span>${hour - 12}:00 </span><span> pm </span></div>`;
          break;
        default:
          // פעולה ברירת מחדל אם אף תנאי לא מתקיים
          break;
      }
    }

    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }
}
